module.exports = __webpack_public_path__ + "img/donations.de3208d8.svg";